import { AGENCY, TEAM_SCREEN } from '@sonder/shared'
import { enabledSections, useStaffDirectory } from '@/data/client'
import { ButtonLink, Eyebrow, TeamCard, useToast } from '@/ui'
import { TopBar } from './TopBar'
import type { PageProps } from './ClientRoutes'

export function TeamPage({ client, config, base }: PageProps) {
  const staff = useStaffDirectory()
  const { toast } = useToast()
  const team = [...config.team].sort((a, b) => a.order - b.order).map((t) => ({ ...t, staff: staff.items.find((s) => s.id === t.staffId) })).filter((t) => t.staff)
  const first = enabledSections(config)[0]?.id ?? 'brands'
  return (
    <>
      <TopBar clientName={client.name} section="Team" homeHref={base} />
      <main id="main" className="mx-auto grid max-w-portal gap-12 px-6 py-section-sm md:px-10">
        <div className="grid max-w-4xl gap-4">
          <Eyebrow>{TEAM_SCREEN.eyebrow}</Eyebrow>
          <h1 className="text-h2">{config.copy?.teamTitle?.trim() || TEAM_SCREEN.title}</h1>
          <p className="max-w-2xl text-charcoal">{config.copy?.teamBody?.trim() || TEAM_SCREEN.body}</p>
        </div>
        <div className="grid grid-cols-2 gap-x-4 gap-y-8 sm:gap-6 md:grid-cols-4">
          {team.map((t) => (
            <TeamCard key={t.staffId} name={t.staff!.name} role={t.roleLabel || t.staff!.title} email={t.staff!.email ?? undefined} photoUrl={t.staff!.photoPath ?? undefined} onCopyEmail={(e) => { void navigator.clipboard.writeText(e); toast('Email copied') }} />
          ))}
        </div>
        <div className="flex flex-wrap items-center justify-between gap-4 border-t border-gray-200 pt-8">
          <p className="text-small text-dim">
            {AGENCY.email} · {AGENCY.phone}
          </p>
          <ButtonLink to={`${base}/onboarding/${first}`}>{TEAM_SCREEN.cta}</ButtonLink>
        </div>
      </main>
    </>
  )
}
